import React, {useState} from "react"
import Row from "@amzn/meridian/row"
import Button from "@amzn/meridian/button"
import ModalExample from "@amzn/meridian/modal";
import Box from "@amzn/meridian/box";
import Text from "@amzn/meridian/text";
import Currency from "../common/currency";
import ModalFooter from "@amzn/meridian/modal/modal-footer";
import Input from "@amzn/meridian/input";
import Column from "@amzn/meridian/column";
import Alert from "@amzn/meridian/alert";
import {getStationCode} from "../../network/NetworkUtil";
import {updateRemittanceRequest} from '../remittance/network/RemittanceAPI';
import commonUtils from "../common/commonUtils";
import AlertModal from "./alertModal";

const SectionDetails = (props) => {
    return (
        <Box spacingInset="small none">
            <Row>
                <Text type="h200">{props.title}</Text></Row>
            <Row>
                <Text color="secondary" type="b200">{props.description}</Text>
            </Row>
        </Box>
    );
}


const OverviewSection = ({onIsExactAmountChange, amountValues}) => {
    console.log({amountValues});

    const {amount = '', variance = '', cashToBeSubmitted = ''} = amountValues;
    return (<Box>
        <Row>
            <SectionDetails title="Overview" description="Confirm amounts to be collected and deposited"/>
        </Row>
        <Column space="small">
            <Row widths={["grid-4", "grid-8"]}>
                <Text type="h100">Amount</Text>
                <Currency amount={amount}/>
            </Row>
            <Row widths={["grid-4", "grid-8"]}>
                <Text type="h100">Variance</Text>
                <Currency isVariance={true} amount={variance}/>
            </Row>
            <Row widths={["grid-4", "grid-8"]}>
                <Text type="h100">Cash to be submitted</Text>
                <Currency amount={cashToBeSubmitted}/>
            </Row>

        </Column>
    </Box>);
}

const RemittanceSection = props => {
    const {remittanceCode: currentRemittanceCode, onRemittanceCodeChange} = props;
    const [remittanceCode, setRemittanceCode] = useState(currentRemittanceCode);
    const [displayConfirmField, setDisplayConfirmField] = useState(false);
    const [confirmRemittanceCode, setConfirmRemittanceCode] = useState("");

    const handleRemittanceCodeChange = event => {
        if (event !== currentRemittanceCode) setDisplayConfirmField(true);
        setRemittanceCode(event);
        onRemittanceCodeChange(event);
    };

    const handleConfirmRemittanceCodeChange = event => {
        setConfirmRemittanceCode(event);
    }

    const validateConfirmRemittanceCode = event => {
        // const newCode = event;
        console.log({confirmRemittanceCode, remittanceCode});
        props.onConfirmedCodeChange(confirmRemittanceCode);
        if (confirmRemittanceCode === remittanceCode) {
            props.onAlert();
        } else {
            props.onAlert({type: "error", message: "Remittance codes do not match."});
        }
    }

    return (
        <Box>
            <Row>
                <SectionDetails
                    title="Remittance Code"
                    description="Record the remittance code provided by the bank on your deposit slip."/>
            </Row>
            <Column>
                <Row width="100%" widths={["grid-8"]}>
                    <Input
                        placeholder="Remittance Code"
                        size="xlarge"
                        value={remittanceCode}
                        onChange={handleRemittanceCodeChange}
                        error={remittanceCode === ""}
                    />
                </Row>
                {
                    displayConfirmField &&
                    <Row width="100%" widths={["grid-8"]}>
                        <Input
                            value={confirmRemittanceCode}
                            placeholder="Confirm Remittance Code"
                            size="xlarge"
                            onChange={handleConfirmRemittanceCodeChange}
                            onBlur={validateConfirmRemittanceCode}
                        />
                    </Row>

                }
            </Column>
        </Box>
    );
}


const EditRemittanceModal = (props) => {
    const [newRemittanceCode, setNewRemittanceCode] = useState();
    const [confirmedCode, setConfirmedCode] = useState();
    const [alertBox, setAlertBox] = useState();
    const [alertModal, setAlertModal] = useState({show: false});
    const onClose = event => {
        setAlertBox();
        setConfirmedCode("");
        setNewRemittanceCode("");
        props.onClose(event);
    }

    const onAlertModalClose = event => {
        onClose(event);
        setAlertModal({show: false});
        window.location.reload();
    }

    const {editRemittanceModalData} = props;
    console.log({editRemittanceModalData, props});
    const remittanceCode = (editRemittanceModalData || {}).remittanceCode;
    const remittanceId = (editRemittanceModalData || {}).remittanceId;
    const overviewAmountValues = {
        amount: ((editRemittanceModalData || {}).expectedAmount || {}),
        variance: ((editRemittanceModalData || {}).variance || {}),
        cashToBeSubmitted: ((editRemittanceModalData || {}).actualAmount || {})
    };


    const submitRemittanceChange = () => {
        const currencyUnit = editRemittanceModalData.actualAmount.unit;
        if(!newRemittanceCode) {
            setAlertBox({type: "error", message: "Enter New Remittance Code"});
            return false;
        }
        if (!commonUtils.isValidRemittanceCode(newRemittanceCode, currencyUnit)) {
            setAlertBox({type: "error", message: "Invalid Remittance Code"});
            return false;
        }

        if (!newRemittanceCode || confirmedCode !== newRemittanceCode) {
            setAlertBox({type: "error", message: "Remittance Code Mismatch"});
            return false;
        }

        return updateRemittanceRequest({
            stationCode: getStationCode(),
            oldRemittanceCode: remittanceCode,
            newRemittanceCode: newRemittanceCode,
            remittanceId: remittanceId
        }).then(response => {
            if (response.status === 200) {
                const {data} = response;
                console.log({data});
                setAlertModal({
                    show: true,
                    type: "success",
                    title: "Success",
                    message: 'Successfully updated remittance code'
                });
            } else {
                setAlertBox({type: "error", message: "Failed to update remittance code"});
            }
        }).catch(err => {
            setAlertBox({type: "error", message: "Failed to update remittance code"});
        });
    }

    return (
        <React.Fragment>
            <ModalExample title="Edit Remittance" open={props.value} scrollContainer="viewport"
                          closeLabel="Close" onClose={onClose}>

                {alertBox && <Alert type={alertBox.type ? alertBox.type : "informational"}>{alertBox.message}</Alert>}
                <Box>
                    <form>
                        <Column spacing="medium">
                            <OverviewSection
                                amountValues={overviewAmountValues}
                            />
                            <RemittanceSection
                                onRemittanceCodeChange={setNewRemittanceCode}
                                onConfirmedCodeChange={setConfirmedCode}
                                remittanceCode={remittanceCode}
                                onAlert={setAlertBox}
                                currencyUnit={overviewAmountValues.amount.unit}
                            />
                        </Column>
                    </form>
                </Box>
                <ModalFooter>
                    <Row alignmentHorizontal="right" widths="fit">
                        <Button type="secondary" size="medium" onClick={onClose}>
                            Cancel
                        </Button>
                        <Button type="primary" size="medium" onClick={submitRemittanceChange}>
                            Done
                        </Button>
                    </Row>
                </ModalFooter>
            </ModalExample>
            <AlertModal
                show={alertModal.show}
                title={alertModal.title}
                type={alertModal.type}
                message={alertModal.message}
                onClose={onAlertModalClose}
            />
        </React.Fragment>
    );
}

export default EditRemittanceModal;


// WEBPACK FOOTER //
// ./src/component/modal/editRemittanceModal.js